<template>
    <div :class="['optimize-image-wapper', !isSwitchNew && (!store.plan_info.optimize_images || !store.plan_info.optimize_theme)  ? 'content-mini-size' : '']">
        <template v-if="isSwitchNew">
            <div class="tranfernew">
                <img src="../assets/swift-logo.svg">
                <img src="../assets/tranfer-new-feature.svg">
                <div class="description text-center">
                    <h2>Increase store speed with Actual Speed in Swift’s new version.</h2>
                    <p>Swift now has an update in Actual Speed embedded in the Shopify admin. Let’s see how it works!</p>
                    <a :href="'https://'+store.shopify_domain + '/admin/apps/'+appName+'/advanced-mode'" target="_blank">Explore now</a>
                </div>
            </div>
        </template>
        <template v-else>
            <div id="popup_swift_e" class="popup_container" >
            <div id="popup_swift_e_child" class="dashboard__new-content-popup">
                <svg @click="closePopup" height="512px" id="Layer_1" style="height: 30px;width: 30px;enable-background:new 0 0 512 512;fill: white;position: relative;top: -35px;right: 0;left: calc(100% + 25px);" version="1.1" viewBox="0 0 512 512" width="512px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path d="M443.6,387.1L312.4,255.4l131.5-130c5.4-5.4,5.4-14.2,0-19.6l-37.4-37.6c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4  L256,197.8L124.9,68.3c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4L68,105.9c-5.4,5.4-5.4,14.2,0,19.6l131.5,130L68.4,387.1  c-2.6,2.6-4.1,6.1-4.1,9.8c0,3.7,1.4,7.2,4.1,9.8l37.4,37.6c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1L256,313.1l130.7,131.1  c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1l37.4-37.6c2.6-2.6,4.1-6.1,4.1-9.8C447.7,393.2,446.2,389.7,443.6,387.1z"></path></svg>
            <div class="dashboard__new-body">
                <div class="dashboard__new-left">
                <strong>SWIFT EXPERT</strong>
                <span>Speed Optimization</span>
                <p>customized by our Experts </p>
                <a-button type="button" class="a-btn a-btn-secondary">
                    <span>View Swift Expert service</span>
                </a-button>
                </div>
                <div class="dashboard__new-middle">
                <h3>What we commit?</h3>
                <ul>
                    <li><i class="fas fa-check-circle"></i><p>Higher score</p></li>
                    <li><i class="fas fa-check-circle"></i><p>Faster site</p></li>
                    <li><i class="fas fa-check-circle"></i><p>Instant result</p></li>
                </ul>
                </div>
            </div>
            </div>
            </div>
            <vue-loading :loading="isLoading"></vue-loading>
            <template v-if="store.plan_info.optimize_images && store.plan_info.optimize_theme">
                <template v-if="!store.have_optimized">
                    <h3 class="m-b-24">{{$t('optimize_image.name')}}</h3>
                    <div class="text-center">
                        <img class="m-b-24" src="./../assets/let-start.svg" alt=''/>
                        <h3 class="m-b-8">{{$t('optimize_image.dont_make_customer_wait')}}</h3>
                        <span class="text-color-secondary">
                            {{$t('optimize_image.description')}}<br>
                            <a class="a-link" href="https://help.perfectapps.io/en/article/what-is-actual-speed-7myi7x/?1605236788163" target="_blank">{{ $t('app.buttons.learn_more') }}</a>
                        </span>
                        <br>
                        <a-button class="m-t-16" type="primary" @click="modalOptimizationMethods.isVisible = true">{{$t('app.buttons.let_start')}}</a-button>
                    </div>
                </template>
                <template v-else-if="overview">
                    <div :class="['optimize-image__header', 'm-b-24']">
                        <h3 class="m-0">{{$t('optimize_image.name')}}</h3>
                        <div class="display-space-between align-items-center position-relative">
                            <span>{{$t('optimize_image.description')}}
                                <a class="a-link" href="https://help.perfectapps.io/en/article/what-is-actual-speed-7myi7x/" target="_blank">{{$t('app.buttons.learn_more')}}</a>
                            </span>
                            <div class="d-flex">
                                <div class="btn-auto-settings" v-if="autoSettings">
                                    <a-button type="secondary"  @click="openModalAutoOptimize" :class="[$prefixClass.btn + '-icon', autoSettings.optimize_image && autoSettings.optimize_theme ? 'active-auto' : 'unactive-auto']">
                                        {{$t('optimize_image.buttons.auto_optimize')}}
                                        <i class="far fa-robot m-l-8 fz-14"></i>
                                    </a-button>
                                    <img v-if="autoSettings.optimize_image && autoSettings.optimize_theme" src="./../assets/icons/check.svg" />
                                </div>
                                <a-button class="m-l-16" :disabled="optimizeBtnDisable" type="primary" @click="modalOptimizationMethods.isVisible = true">{{$t('optimize_image.buttons.optimize_now')}}</a-button>
                            </div>
                            <auto-optimize-banner v-model="autoBannerVisible" @set-up="openModalAutoOptimize"></auto-optimize-banner>
                        </div>
                    </div>
                    <bar-notification-opt class="m-b-16" v-model="notificationBar" @optimize-now="modalOptimizationMethods.isVisible = true"></bar-notification-opt>
                    <div class="optimize-image__optimization-info d-flex">
                        <div :class="[$prefixClass.card + '-stroke', 'optimization-info__box m-r-16']">
                            <div :class="['display-space-between m-b-16']">
                                <div class="d-flex align-items-center">
                                    <h6 class="m-r-8 m-b-0">{{$t('optimize_image.theme_optimization')}}</h6>
                                    <a-badge v-if="overview.theme.show_remove_code" :class="[$prefixClass.badge + '-solid publish' ]">Published</a-badge>
                                </div>
                                <a v-if="overview.theme.show_remove_code" :class="$prefixClass.link" @click="troubleWithThemeVisible = true">I have trouble with theme</a>
                            </div>
                            <div class="d-flex">
                                <summary-box
                                    title="Total file optimized"
                                    :total="overview.theme.total_optimized"
                                >
                                </summary-box>
                                <summary-box class="m-l-15"
                                    title="Total file saved"
                                    :total="overview.theme.total_saved"
                                    :isFormatSize="true"
                                >
                                </summary-box>
                            </div>
                        </div>
                        <div :class="[$prefixClass.card + '-stroke', 'optimization-info__box']">
                            <h6 class="m-b-16">{{$t('optimize_image.image_optimization')}}</h6>
                            <div class="d-flex">
                                <summary-box
                                    title="Total image optimized"
                                    :total="overview.image.total_optimized"
                                >
                                </summary-box>
                                <summary-box class="m-l-15"
                                    title="Total image saved"
                                    :total="overview.image.total_saved"
                                    :isFormatSize="true"
                                >
                                </summary-box>
                            </div>
                        </div>
                    </div>
                    <!-- Show if unpublish theme -->
                    <div v-if="overview.theme.theme_status === 'preview' && !optimizeBtnDisable" :class="[$prefixClass.card + '-stroke', 'optimize-image__theme-unpublish m-t-8']">
                        <div>
                            <h6 class="m-0">{{$t('optimize_image.theme_unpublish')}}</h6>
                            <span>{{$t('optimize_image.preview_publish')}}</span>
                        </div>
                        <div>
                            <a-button class="m-r-8 white-color" type="subtle" @click="showModalPreviewTheme">{{$t('optimize_image.buttons.preview')}}</a-button>
                            <a-tooltip :prefixCls="$prefixClass.tooltip"
                                overlayClassName="m-tooltip-common"
                                placement="top"
                            >
                                <template v-if="disabledPublishAction" slot="title">
                                    <span v-html="$t('optimize_image.publish_tooltip')"></span>
                                </template>
                                <a-button type="primary" @click="onPublishTheme" :disabled="disabledPublishAction">{{$t('optimize_image.buttons.publish')}}</a-button>
                            </a-tooltip>
                            <a-button class="m-l-8 danger-color" type="primary" @click="showModalRemoveTheme"><i class="fas fa-trash-alt"></i></a-button>
                        </div>
                    </div>
                    <!-- End -->
                    <h5 class="m-b-16 m-t-30">{{ $t('optimize_image.optimize_history') }}</h5>
                    <div class="optimize-image__history m-t-16 table-list" v-if="source">
                        <vue-table-empty class="m-t-48 m-b-72" v-if="source.data.length <= 0" :src="require('@/assets/images/data-empty.svg')">
                            <template slot="description">
                                <h5 class="font-weight-normal m-b-0">No data to display</h5>
                            </template>
                        </vue-table-empty>
                        <a-table v-else
                            :prefixCls="$prefixClass.table"
                            :columns="columns"
                            :dataSource="source.data"
                            :rowKey="record => record.id"
                            :rowSelection="null"
                            :pagination="false"
                            :class="[source.last_page > 1 ? '' : 'm-table-border-bottom-none']"
                        >
                            <template slot="name" slot-scope="text, record">
                                <h6 class="m-b-0">{{formatLogId(record.id)}}</h6>
                            </template>
                            <template slot="time" slot-scope="text">
                                {{ formatDateTimeLog(text) }}
                            </template>
                            <template slot="images_count" slot-scope="text, record">
                                {{text ? text + (Number(text) > 1 ? ' images' : ' image') : '--'}}
                                <span
                                    v-if="rateData(record.image_total_origin_size, record.image_total_optimize_size) !== 0 && record.image_total_optimize_size !== 0"
                                    :class="[rateData(record.image_total_origin_size, record.image_total_optimize_size) > 0 ? 'danger-color' : 'success-color', 'm-l-4']">
                                    (<i
                                        :class="['fas', rateData(record.image_total_origin_size, record.image_total_optimize_size) > 0 ? 'fa-arrow-up' : 'fa-arrow-down']"></i>
                                        {{rateData(record.image_total_origin_size, record.image_total_optimize_size) | abs}}%)
                                </span>
                            </template>
                            <template slot="details_count" slot-scope="text">
                                {{text ? text + (Number(text) > 1 ? ' files' : ' file') : '--'}}
                            </template>
                            <template slot="action" slot-scope="text">
                                <router-link :to="{name: $routerName.OPTIMIZATION_DETAIL, params: {id: text} }">
                                    <a-button style="float: right;" type="secondary">{{ $t('optimize_image.view_detail') }}</a-button>
                                </router-link>
                            </template>
                            <template slot="footer" v-if="source.last_page > 1">
                                <vue-pagination :routerLink="false" :pageRange="3" v-model="filter.page" :total="source.last_page"></vue-pagination>
                            </template>
                        </a-table>
                    </div>
                </template>
                <vue-modal-optimize-methods
                    v-model="modalOptimizationMethods"
                    @doOptimize="doOptimize"
                >
                </vue-modal-optimize-methods>
                <modal-image-limit v-model="imageLimitVisible"
                    :isOptimizeTheme="optimizeSettings.optimize_theme"
                    @on-optimize-theme="optimizeThemeOnly"
                    @buy-more-images="buyMoreImages"
                >
                </modal-image-limit>
                <vue-modal-buy-more-images v-if="imagePlans"
                    v-model="buyMoreImageVisible"
                    :optimizeSettings="optimizeSettings"
                >
                </vue-modal-buy-more-images>
                <vue-modal-subscribe-image v-model="subscribeImageVisible" @buy-more-images="buyMoreImageVisible = true"></vue-modal-subscribe-image>
                <vue-modal-sucess v-model="modalPurchaseSuccess" :closable="true">
                    <template v-if="continuteOptimize" slot="action">
                        <a-button class="m-t-16 m-r-8" type="secondary" @click="modalPurchaseSuccess.isVisible = false">Later</a-button>
                        <a-button type="primary" @click="doOptimize(optimizeSettings)">Continute to optimize</a-button>
                    </template>
                </vue-modal-sucess>
                <modal-trouble-with-theme v-model="troubleWithThemeVisible"
                    @onRemoveCode="onRemoveCode"
                    @contactForHelp="contactForHelp"
                >
                </modal-trouble-with-theme>

                <!-- Publish Theme -->
                <modal-publish-theme v-model="modalPublishTheme"
                    @do-contact="openContact" @publish-now="onPublishTheme">
                </modal-publish-theme>
                <!-- Auto Setting -->
                <modal-auto-setting
                    v-model="modalAutoSetting"
                    @save-auto-setting="saveAutoSetting"
                >
                </modal-auto-setting>

                <!-- Remove test theme -->
                <modal-notification v-model="modalNotification"
                    @remove-theme="onRemoveTheme"
                >
                </modal-notification>
                <modal-publish-theme-success v-model="modalPublishThemeSuccess"
                    @bad-publish="troubleWithThemeVisible = true">
                </modal-publish-theme-success>
            </template>
            <template v-else>
                <h3 class="m-0">{{$t('optimize_image.name')}}</h3>
                <span class="text-color-secondary">
                    {{$t('optimize_image.description')}}<br>
                    <a class="a-link" href="https://help.perfectapps.io/en/article/what-is-actual-speed-7myi7x/?1605236788163" target="_blank">{{ $t('app.buttons.learn_more') }}</a>
                </span>
                <vue-block-function class="m-t-24"></vue-block-function>
            </template>
        </template>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { types as typesOptimize } from './../constant'
import { types as typesAuth } from "@/modules/auth/constant"
import { types as typesCharge } from '@/modules/charge/constant'
import SummaryBox from './../components/SummaryBox'
import BarNotificationOpt from './../components/BarNotificationOpt'
import ModalImageLimit from './../components/ModalImageLimit'
import ModalAutoSetting from './../components/ModalAutoSetting'
import ModalNotification from './../components/ModalNotification'
import ModalPublishTheme from './../components/ModalPublishTheme'
import ModalTroubleWithTheme from './../components/ModalTroubleWithTheme'
import AutoOptimizeBanner from './../components/AutoOptimizeBanner'
import ModalPublishThemeSuccess from './../components/ModalPublishThemeSuccess'
import cookie from 'js-cookie'
import isEmpty from "lodash/isEmpty"
import { store } from '@/main.js'
import Pusher from "pusher-js"
import { PricingFeatureList } from '../../charge/views/PricingPlan'
const pusher = new Pusher(`${process.env.VUE_APP_PUSHER_KEY}`, {
    cluster: "ap1"
});
export default {
    name: 'ActualSpeed',
    metaInfo: {
        title: 'ActualSpeed'
    },
    components: {
        SummaryBox,
        BarNotificationOpt,
        ModalImageLimit,
        ModalAutoSetting,
        ModalNotification,
        ModalPublishTheme,
        ModalTroubleWithTheme,
        AutoOptimizeBanner,
        ModalPublishThemeSuccess
    },
    data() {
        return {
            isSwitchNew: true, // tính năng này sẽ không support trên 2.0 nữa
            //popup: this.loadPopup(),
            isLoading: false,
            autoBannerVisible: false,
            statusLoading: 'first_time',
            continuteOptimize: false,
            imageLimitVisible: false,
            buyMoreImageVisible: false,
            troubleWithThemeVisible: false,
            subscribeImageVisible: false,
            disabledPublishAction: false,
            modalPublishThemeSuccess: {
                visible: false
            },
            modalSucessMedium: {
                isVisible: false,
                title: this.$t('dashboard.component.features_unlocked'),
                description: this.$t('dashboard.component.premium_zone')
            },
            optimizeSettings: {
                optimize_image: false,
                optimize_theme: false,
                settings: []
            },
            modalAutoSetting: {
                isVisible: false,
                formAutoSettings: {
                    optimize_image: 0,
                    optimize_theme: 0
                }
            },
            modalPurchaseSuccess: {
                isVisible: false,
                title: this.$t('app.modal.purchase_sucessfully')
            },
            modalPublishTheme: {
                isVisible: false,
            },
            filter: {
                page: 1
            },
            modalOptimizationMethods: {
                isVisible: false,
                formSettings: {
                    optimize_image: false,
                    optimize_theme: true,
                    settings: []
                }
            },
            notificationBar: {
                isVisible: false,
                type: 'needed',
                detail: {},
            },
            columns: [{
                    title: "Log",
                    dataIndex: "name",
                    scopedSlots: {
                        customRender: "name"
                    },
                    width: "20%",
                },
                {
                    title: "Time",
                    dataIndex: "updated_at",
                    scopedSlots: {
                        customRender: "time"
                    },
                    width: "18%",
                },
                {
                    title: "Image Optimization",
                    dataIndex: "images_count",
                    scopedSlots: {
                        customRender: "images_count"
                    },
                    width: "18%",
                },
                {
                    title: "Theme Optimization",
                    dataIndex: "details_count",
                    scopedSlots: {
                        customRender: "details_count"
                    },
                    width: "18%",
                },
                {
                    title: "Theme",
                    dataIndex: "theme_name",
                    scopedSlots: {
                        customRender: "theme_name"
                    }
                },
                {
                    title: "",
                    dataIndex: "id",
                    scopedSlots: {
                        customRender: "action"
                    }
                }
            ],
            source: null,
            modalNotification: {
                isVisible: false,
                type: 'primary',
                title: '',
                description: '',
                btnText: '',
                action: ''
            }
        }
    },
    beforeRouteLeave (to, from, next) {
        $(".m-toast-removing-theme").remove()
        $(".m-toast-publish-change").remove()
        next()
    },
    computed: {
        ...mapGetters({
            store: typesAuth.getters.GET_STORE,
            overview: typesOptimize.getters.GET_OVER_VIEW,
            settingsTheme: typesOptimize.getters.GET_SETTINGS_THEME,
            autoSettings: typesOptimize.getters.GET_AUTO_SETTINGS,
            newOptimize: typesOptimize.getters.GET_NEW_OPTIMIZE,
            imagePlans: typesCharge.getters.GET_IMAGE_PLANS,
            isShowPreviewTheme : 'getShowPreviewTheme',
            actualOptimizeSucess : 'getActualOptimizeSuccess',
            actualStopOptimize : 'getActualStopOptimize',
            actualOptimizing : 'getActualOptimizing',
            autoOpenOptimizeMethod: 'getAutoOpenOptimizeMethod'
        }),
        optimizeBtnDisable() {
            return this.actualOptimizing
        }
    },
    watch: {
        filter: {
            async handler() {
                await this.getAllLogs()
            },
            deep: true
        },
        newOptimize: {
            handler() {
                this.featchNewOptimize()
            },
            deep: true
        },
        autoSettings: {
            handler() {
                this.featchNewOptimize()
            },
            deep: true
        },
        isShowPreviewTheme: {
            handler(val) {
                if (val) {
                    this.showModalPreviewTheme()
                }
            },
            deep: true
        },
        actualOptimizeSucess: {
            handler(val) {
                if ( val ) {
                    this.reloadData(this.actualStopOptimize)
                }
            },
            deep: true
        },
        actualOptimizing: {
            handler(val) {
                if ( !val ) {
                    cookie.remove('actual_optimize_settings')
                }
            },
            deep: true
        },
        autoOpenOptimizeMethod: {
            handler(value) {
                this.modalOptimizationMethods.isVisible = value
            },
            deep: true
        }
    },
    created() {
        this.featchData()
    },
    mounted(){
        window.location.href = `https://${store.shopify_domain}/admin/apps/${process.env.VUE_APP_NAME_V3 || 'swift-3'}`;
    },
    methods: {
            popupCheckCookie(name){
                var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
                if (match) {
                  return match[2];
                }else{ return false; }
             },
             popupGetDay(){
               var today = new Date();
               var dd = String(today.getDate()).padStart(2, '0');
               var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
               var yyyy = today.getFullYear();
               today = mm + '/' + dd + '/' + yyyy;
               return today;
             },
             popupSetCookie(){
               document.cookie = "cPopup=" + String(this.popupGetDay() );
             },
            loadPopup(){
              if( this.popupCheckCookie("cPopup") == false || this.popupCheckCookie("cPopup") != this.popupGetDay() ){
                this.popupSetCookie();
                // show popup
                setTimeout(function(){
                  document.getElementById("popup_swift_e").style = "display:flex";
                  setTimeout(function(){
                    document.getElementById("popup_swift_e").style = "display:flex;opacity:1";
                    document.getElementById("popup_swift_e_child").style = "opacity:1";
                  }, 600);
                }, 3000);
                // end show popup
              }

            },
            closePopup(){

                document.getElementById("popup_swift_e").style = "display:flex;opacity:0;transition: all .3s";
                document.getElementById("popup_swift_e_child").style = "opacity:0;transition: all .3s";
                setTimeout(function(){
                  document.getElementById("popup_swift_e").style = "display:none";
                }, 301);

            },
        ...mapActions({
            getStore: typesAuth.actions.GET_STORE,
            optimizeAll: typesOptimize.actions.OPTIMIZE,
            getActualOverview: typesOptimize.actions.GET_OVER_VIEW,
            getTotalImages: typesOptimize.actions.GET_TOTAL_IMAGES,
            getLogs: typesOptimize.actions.GET_ALL_LOGS,
            getLogDetail: typesOptimize.actions.GET_LOG_DETAIL,
            startOptimize: typesOptimize.actions.START_OPTIMIZE,
            checkNewOptimize: typesOptimize.actions.CHECK_NEW_OPTIMIZE,
            getProcess: typesOptimize.actions.GET_PROCESS,
            getSettingsTheme: typesOptimize.actions.GET_SETTINGS_THEME,
            getAutoSettings: typesOptimize.actions.GET_AUTO_SETTINGS,
            saveAutoSettings: typesOptimize.actions.SAVE_AUTO_SETTINGS,
            removeDuplicateTheme: typesOptimize.actions.REMOVE_DUPLICATE_THEME,
            publishChange: typesOptimize.actions.PUBLISH_CHANGE,
            removeCode: typesOptimize.actions.REMOVE_CODE,
            updateTooltip: typesOptimize.actions.UPDATE_TOOLTIP,
        }),
        async featchData() {
            this.isLoading = true
            this.disabledPublishAction = !cookie.get(`preview_after_optimized_${this.store.id}`) || cookie.get(`preview_after_optimized_${this.store.id}`) !== 'true'
            this.checkFromBuyWord()
            await this.getActualOverview()
            this.listenRemoveCodePusher()
            this.listenPublishChangePusher()
            if ( !this.settingsTheme ) {
                await this.getSettingsTheme()
            }
            await this.getAllLogs()
            if (this.isShowPreviewTheme) {
                this.showModalPreviewTheme()
            }
            if ( !this.newOptimize ) {
                await this.checkNewOptimize()
            } else {
                this.featchNewOptimize()
            }
            this.modalOptimizationMethods.isVisible = this.autoOpenOptimizeMethod
            for (var key in this.settingsTheme) {
                if (this.settingsTheme[key] == 1 && key !== 'id') {
                    this.modalOptimizationMethods.formSettings.settings.push(key)
                }
            }
            this.isLoading = false
        },
        async featchNewOptimize() {
            if ( this.newOptimize && this.autoSettings ) {
                let data = this.$clone(this.newOptimize)
                let type = ( data &&  data.image && data.image.total > this.maximumImageInApp && data.theme && data.theme.total > this.maximumThemeInApp && !this.autoSettings.optimize_image && !this.autoSettings.optimize_theme) ? 'all' : ( data.image && data.image.total > this.maximumImageInApp && !this.autoSettings.optimize_image ? 'image' : ( data.theme && data.theme.total > this.maximumThemeInApp && !this.autoSettings.optimize_theme ? 'theme' : ''))
                if ( type ) {
                    this.notificationBar.type = type
                    this.notificationBar.detail = data.image
                    this.notificationBar.isVisible = this.notificationBar.type == 'theme' && cookie.get('show-modal-new-theme') ? false : true
                    if ( this.notificationBar.type == 'theme' && !cookie.get('show-modal-new-theme') ) {
                        cookie.set('show-modal-new-theme', true, { expires: 30 })
                    }
                } else {
                    this.notificationBar.isVisible = false
                }
            }
        },
        checkFromBuyWord() {
            let query = this.$route.query
            this.continuteOptimize = cookie.get('optimize_settings') ? true : false
            if ( !isEmpty(query) && query.hasOwnProperty('image_plan_name')) {
                this.modalPurchaseSuccess.isVisible = true
                this.modalPurchaseSuccess.description = this.$t('app.modal.purchase_sucess_description', {num: query.image_plan_name})
                this.setQuery({})
            }
            if ( this.continuteOptimize ) {
                this.optimizeSettings = JSON.parse(cookie.get('optimize_settings'))
                cookie.remove('optimize_settings')
            }
        },
        async getAllLogs() {
            let self = this
            this.isLoading = true
            await this.getLogs({ page: this.filter.page }).then(res => {
                let { status = false, data = [] } = res.data
                if (status) {
                    self.filter.page = data.current_page
                    self.source = data
                    self.statusLoading = "exist_data"
                } else {
                    self.statusLoading = "no_data"
                }
                self.isLoading = false
            }).catch(e => {
                self.isLoading = false
                console.log(e);
            });
        },
        setQuery(query) {
            this.pushRouterLinkDefault({
                name: this.$routerName.OPTIMIZE_IMAGE,
                query: query,
            });
        },
        async optimize() {
            let self = this
            this.isLoading = true
            this.autoBannerVisible = false
            await this.optimizeAll(this.optimizeSettings).then(async res => {
                let { image =  null, theme = null } = res.data
                if ( ( image && image.status) ||  ( theme && theme.status ) ) {
                    cookie.set('actual_optimize_settings', self.optimizeSettings, {expires: 1} )
                    self.getProcess()
                    if ( !self.store.have_optimized ) {
                        await self.startOptimize()
                        self.getStore()
                    }
                }
                if ( image && !image.status ) {
                    if ( image.message == 404 ) {
                        self.toastSuccess({
                            title: self.$t('optimize_image.errors.all_image_optimized'),
                            message: self.$t('optimize_image.errors.no_images_found'),
                            duration: 4
                        })
                    } else {
                        self.toastError({
                            title: "Error",
                            message: 'Somethings went wrong',
                            duration: 4
                        })
                    }
                }
                // if ( theme && !theme.status ) {
                //     if ( theme.message == 404 ) {
                //         self.toastSuccess({
                //             title: self.$t('optimize_image.errors.all_theme_optimized'),
                //             message: self.$t('optimize_image.errors.no_codes_found'),
                //             duration: 4
                //         })
                //     } else {
                //         self.toastError({
                //             title: "Error",
                //             message: 'Somethings went wrong',
                //             duration: 4
                //         })
                //     }
                // }
                self.isLoading = false
            }).catch(e => {
                self.isLoading = false
                console.log(e);
            })
        },
        optimizeThemeOnly() {
            this.optimizeSettings.optimize_image = false
            this.optimize()
        },
        async doOptimize(formSettings=null) {
            this.optimizeSettings = formSettings ? this.$clone(formSettings) : this.optimizeSettings
            this.notificationBar.isVisible = false
            this.modalPurchaseSuccess.isVisible = false
            this.isLoading = true
            if ( this.optimizeSettings.optimize_image ) {
                if ( this.store && Number(this.store.buymore_images_available + this.store.default_images_available) === 0 ) {
                    this.modalOptimizationMethods.isVisible = false
                    this.imageLimitVisible = true
                    this.isLoading = false
                    return false
                }
            }
            this.optimize()
        },
        buyMoreImages() {
            if (this.store && this.store.trial_end && new Date(this.store.trial_end) > new Date()) {
                this.subscribeImageVisible = true
            } else {
                this.buyMoreImageVisible = true
            }
        },
        async reloadData() {
            this.getProcess()
            this.getAllLogs()
            this.checkNewOptimize()
            if ( !this.actualStopOptimize && this.overview.tooltip_auto_setting_times < 1 ) {
                this.autoBannerVisible = !this.actualOptimizing && ( !this.autoSettings.optimize_image || !this.autoSettings.optimize_theme )
                if ( this.autoBannerVisible ) {
                    await this.updateTooltip()
                }
            }
            this.getActualOverview()
            cookie.remove(`preview_after_optimized_${this.store.id}`)
            this.disabledPublishAction = true
            store.commit('setOptimizeSuccess', false)
            store.commit('setStopOptimize', false)
        },
        listenRemoveCodePusher() {
            if ( this.overview.theme.show_remove_code ) {
                let self = this
                let channelName = "remove-optimize-code-channel-" + this.store.id
                let channel = pusher.subscribe(channelName)
                channel.unbind("remove-optimize-code")
                $(".m-toast-removing-theme").remove()
                if ( cookie.get('toast-removing-theme') ) {
                    this.toastInfo({title: this.$t('optimize_image.remove_theme'), message: this.$t('optimize_image.remove_theme_description'), duration: 0, className: 'm-toast-removing-theme'})
                    channel.bind("remove-optimize-code", function(data) {
                        let { storeId=0, message='error' } = data
                        channel.unbind("remove-optimize-code")
                        cookie.remove('toast-removing-theme')
                        $(".m-toast-removing-theme").remove()
                        if ( message === 'success' ) {
                            self.getActualOverview();
                            self.toastSuccess({
                                title: "Remove theme changes succesfully",
                                message: 'Optimized theme removed',
                                duration: 4
                            })
                        } else {
                            self.toastError({
                                title: "Error",
                                message: 'Somethings went wrong',
                                duration: 4
                            })
                        }
                    });
                }
            } else {
                cookie.remove('toast-removing-theme')
                $(".m-toast-removing-theme").remove()
            }
        },
        listenPublishChangePusher() {
            if ( this.overview.theme.theme_status === 'preview' ) {
                let self = this
                let channelName = "publish-change-channel-" + this.store.id
                let channel = pusher.subscribe(channelName)
                channel.unbind("publish-change")
                $(".m-toast-publish-change").remove()
                if ( cookie.get('toast-publish-change') ) {
                    this.toastInfo({title: this.$t('optimize_image.publish_theme'), message: this.$t('optimize_image.publish_theme_description'), duration: 0, className: 'm-toast-publish-change'})
                    channel.bind("publish-change", function(data) {
                        let { storeId=0, message='error' } = data
                        channel.unbind("publish-change")
                        cookie.remove('toast-publish-change')
                        $(".m-toast-publish-change").remove()
                        if ( message === 'success' ) {
                            self.getActualOverview();
                            store.commit('setShowPreviewTheme', false)
                            self.modalPublishThemeSuccess.visible = true
                            self.toastSuccess({
                                title: "Publishing theme successfully",
                                message: 'Your theme just got published',
                                duration: 4
                            })
                        } else {
                            self.toastError({
                                title: "Error",
                                message: 'Somethings went wrong',
                                duration: 4
                            })
                        }
                    });
                }
            } else {
                cookie.remove('toast-publish-change')
                $(".m-toast-publish-change").remove()
            }
        },
        async onPublishTheme() {
            let self = this
            this.isLoading = true
            this.modalNotification.isVisible = false
            await this.publishChange().then(res => {
                let { status = false, data = [] } = res.data
                if (status) {
                    cookie.set('toast-publish-change', true, { expires: 1})
                    self.listenPublishChangePusher()
                } else {
                    self.toastError({
                        title: "Error",
                        message: 'Somethings went wrong',
                        duration: 4
                    })
                }
                self.isLoading = false
            }).catch(e => {
                self.isLoading = false
                console.log(e);
            });
        },
        async onRemoveCode() {
            let self = this
            this.isLoading = true
            this.modalNotification.isVisible = false
            await this.removeCode().then(res => {
                let { status = false, data = [] } = res.data
                if (status) {
                    cookie.set('toast-removing-theme', true, { expires: 1 })
                    self.listenRemoveCodePusher()
                } else {
                    self.toastError({
                        title: "Error",
                        message: 'Somethings went wrong',
                        duration: 4
                    })
                }
                self.isLoading = false
            }).catch(e => {
                self.isLoading = false
                console.log(e);
            });
        },
        contactForHelp() {
            $crisp.push(['do', 'chat:open'])
            // $linebase.do('widget','open')
        },
        // Save Auto Settings
        async saveAutoSetting(form) {
            let self = this
            this.isLoading = true
            let params = this.$clone(form)
            for (var key in params) {
                params[key] = params[key] ? 1 : 0
            }
            await this.saveAutoSettings(params).then(res => {
                let { status = false, data = null } = res.data
                if (status) {
                    self.toastSuccess({
                        title: self.$t('optimize_image.save_auto_settings.title_toast_success'),
                        message: self.$t('optimize_image.save_auto_settings.content_toast_success'),
                        duration: 4
                    })
                    self.getAutoSettings()
                } else {
                    self.toastError({
                        title: self.$t('optimize_image.save_auto_settings.title_toast_error'),
                        message: self.$t('optimize_image.save_auto_settings.content_toast_error'),
                        duration: 4
                    })
                }
                self.isLoading = false
            }).catch(e => {
                self.isLoading = false
                console.log(e);
            });
        },
        // Preview theme
        showModalPreviewTheme() {
            // Go to preview store
            window.open('https://' + this.store.domain + '/?fts=0&preview_theme_id=' + this.overview.theme.theme_preview_id, '_blank');
            // Show modal
            cookie.set(`preview_after_optimized_${this.store.id}`, true, { expires: 30 } )
            this.disabledPublishAction = false
            this.modalPublishTheme.isVisible = true
        },
        openContact() {
            alert('open contact')
        },
        showModalRemoveTheme() {
            this.modalNotification.title = this.$t('optimize_image.modal_remove_theme.title')
            this.modalNotification.description = this.$t('optimize_image.modal_remove_theme.content')
            this.modalNotification.btnText = this.$t('optimize_image.modal_remove_theme.remove')
            this.modalNotification.action = 'remove-theme'
            this.modalNotification.isVisible = true
        },
        async onRemoveTheme() {
            let self = this
            this.isLoading = true
            await this.removeDuplicateTheme().then(res => {
                let { status = false, data = [] } = res.data
                if (status) {
                    self.getActualOverview()
                    self.toastSuccess({
                        title: "Remove theme succesfully",
                        message: 'Optimized theme removed',
                        duration: 4
                    })
                } else {
                    self.toastError({
                        title: "Error",
                        message: 'Somethings went wrong',
                        duration: 4
                    })
                }
                self.isLoading = false
            }).catch(e => {
                self.isLoading = false
                console.log(e);
            });
        },
        // Show modal Auto Settings
        openModalAutoOptimize() {
            this.modalAutoSetting.formAutoSettings.optimize_image = this.autoSettings.optimize_image
            this.modalAutoSetting.formAutoSettings.optimize_theme = this.autoSettings.optimize_theme
            this.modalAutoSetting.isVisible = true
        }
    }
}
</script>
<style lang="scss">

.tranfernew{
    width: 100%;
    height: calc(100vh - 112px);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    >img{
        margin-bottom: 40px;
    }
    .description{
        font-family: 'Segoe UI';
        font-style: normal;
        >h2{
            color: #2F43D7;
            margin-bottom: 16px;
        }
        >p{
            font-weight: 400;
            font-size: 16px;
            line-height: 24px;
            color: #000000;
            margin-bottom: 16px;
        }
        >a{
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 5px 16px;
            width: 122px;
            height: 34px;
            background: #2F43D7;
            border-radius: 4px;

            font-weight: 600;
            font-size: 16px;
            line-height: 24px;
            display: flex;
            align-items: center;
            text-align: center;
            color: #FFFFFF;
            margin: auto;
        }
    }
}
.popup_container{
  display: none;
  opacity:0;
  position: fixed;
  top: 0px;
  width: 100%;
  left: 0;
  height: 100vh;
  z-index: 9999;
  background-color:#0000005e;
  transition:all 1s;
}
#popup_swift_e_child{
  align-self:center;
  margin:auto;
  opacity:0;
  transition:all 1s;
}
.dashboard__new-content-popup {
    padding: 20px 40px 40px 40px;
    background-image: url(/img/bg-new.43b8604e.png);
    border-radius: 4px;
    background-position: top right;
    background-size: cover;
}
.dashboard__new-body {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
}
.dashboard__new-left {
    margin-right: 46px;
}
.a-btn-secondary, .a-btn-secondary:focus {
    border-color: #d9e2ec;
    color: #162a41;
}
.dashboard__new-middle {
    color: #FFFFFF;
    padding: 20px 32px;
    background: rgba(146, 159, 254, 0.2);
    -webkit-box-shadow: 0px 0px 20px rgb(0 0 0 / 25%);
    box-shadow: 0px 0px 20px rgb(0 0 0 / 25%);
    border-radius: 12px;
}
.dashboard__new-left > strong {
    color: #FFE600;
}
.dashboard__new-left > span {
    font-size: 50px;
    font-weight: 600;
    display: block;
    color: #FFFFFF;
}
.dashboard__new-left > p {
    color: #FFFFFF;
    margin-bottom: 24px;
    font-size: 24px;
}
#popup_swift_e svg{cursor:pointer}
    .optimize-image {
        &__header {
            .btn-auto-settings {
                position: relative;
                .active-auto {
                    border-color: $success-color;
                    color: $success-color;
                    i {
                        color: $success-color;
                    }
                }
                .unactive-auto {
                    color: $primary-color;
                    i {
                        color: $primary-color;
                    }
                }
                img {
                    position: absolute;
                    right: 0;
                    bottom: 0;
                    margin-bottom: -6px;
                    margin-right: -6px;
                }
            }
        }
        &__optimization-info {
            .optimization-info {
                &__box {
                    .a-badge {
                        &.publish {
                            border-color: $success-color;
                            background-color: $success-color;
                        }
                    }
                    width: 100%;
                    padding: 16px;
                }
            }
        }
        &__theme-unpublish {
            display: flex;
            align-items: center;
            justify-content: space-between;
            color: $white-color;
            padding: 16px 24px;
            background: $primary-color;
            button {
                color: $white-color;
            }
            .a-btn-primary {
                color: $primary-color;
                background: $white-color;
            }
        }
        &__history {
            border: 1px solid $line-color;
            border-radius: 4px;
            padding-top: 16px;
            .m-table {
                &-row {
                    td {
                        font-size: $font-size-base;
                    }
                }
                &-tbody {
                    >tr>td {
                        padding: 10px 16px;
                    }
                    >tr:hover {
                        background-color: $background-color !important;
                    }
                }
                &-thead>tr>th {
                    padding-top: 0;
                }
            }
        }
    }
</style>
